import axios from "axios";
import { useState, useRef, useContext } from "react";
import { AuthContext } from "../../../../context/App-Context";
// ← styles below

const PhotoVaultPictureAddForm = (props) => {
  const auth = useContext(AuthContext);
  const [selectedImages, setSelectedImages] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const fileInputRef = useRef(null);

  // Helper function to compress images dynamically on the frontend
  const compressImage = (file, maxSizeMB = 4.5) => {
    return new Promise((resolve, reject) => {
      // Don't compress videos, just return them as-is
      if (file.type.startsWith("video/")) {
        resolve(file);
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          let width = img.width;
          let height = img.height;

          // Max dimensions to ensure file size drops significantly
          const MAX_WIDTH = 1920;
          const MAX_HEIGHT = 1920;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          // Compress to JPEG with 0.8 quality
          canvas.toBlob(
            (blob) => {
              if (blob) {
                // Convert blob back to a File object so Axios accepts it
                const compressedFile = new File([blob], file.name, {
                  type: "image/jpeg",
                  lastModified: Date.now(),
                });
                resolve(compressedFile);
              } else {
                reject(new Error("Canvas to Blob failed"));
              }
            },
            "image/jpeg",
            0.8
          );
        };
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const MAX_IMAGES = 10;

  //   console.log(auth.loginVar); /// calls username

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    // console.log(
    //   "Selected files:",
    //   files.map((f) => f.name)
    // );

    const newImages = [...selectedImages, ...files];
    if (newImages.length > MAX_IMAGES) {
      alert(`Max ${MAX_IMAGES} images allowed.`);
      return;
    }

    setSelectedImages(newImages);
    // console.log("New state length:", newImages.length);
  };

  const removeImage = (index) => {
    const updated = selectedImages.filter((_, i) => i !== index);
    setSelectedImages(updated);
  };

  const clearAll = () => {
    setSelectedImages([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedImages.length === 0) {
      alert("Please select at least one image.");
      return;
    }

    setIsSubmitting(true);

    try {
      const formData = new FormData();

      for (let i = 0; i < selectedImages.length; i++) {
        const originalFile = selectedImages[i];

        try {
          // Compresses photos, ignores videos
          const processedFile = await compressImage(originalFile);
          formData.append("images", processedFile);
        } catch (err) {
          console.error("Compression error:", err);
          // Fallback to original file if compression fails
          formData.append("images", originalFile);
        }
      }

      //// album index
      formData.append("photoVaultAlbumIndex", props.photoVaultAlbumIndex);
      //// album name
      formData.append("photoVaultAlbumName", props.photoVaultAlbumName);
      /////
      formData.append("userUsername", auth.loginVar);
      // Example axios post (uncomment & adjust)
      // const response = await axios.post('/api/upload', formData, {
      //   headers: { 'Content-Type': 'multipart/form-data' }
      // });
      // console.log('Upload success:', response.data);

      // console.log(
      //   "Files ready to send:",
      //   selectedImages.map((f) => f.name)
      // );
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/u-ablts/createPhotosInPhotoVault`,
        formData
        // {
        //   Authorization: `Bearer ${auth.token}`,
        //   // Do NOT set Content-Type — let Axios add the boundary
        // }
      );

      // Reset form after success
      setSelectedImages([]);
      if (fileInputRef.current) fileInputRef.current.value = "";
      alert("Images uploaded successfully!");
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Something went wrong during upload.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="photovault-container">
      <h2>Upload up to {MAX_IMAGES} images</h2>

      <form onSubmit={handleSubmit}>
        {/* Hidden real input */}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          multiple
          onChange={handleFileChange}
          style={{ display: "none" }}
          id={props.photoVaultAlbumIndex}
        />

        <label
          htmlFor={props.photoVaultAlbumIndex}
          className={`photovault-upload-btn ${
            selectedImages.length >= MAX_IMAGES ? "disabled" : ""
          }`}
          onClick={() => console.log("Label clicked — should open file picker")}
        >
          {selectedImages.length >= MAX_IMAGES ? "Max reached" : "+ Add Photos"}
        </label>

        {/* Preview grid */}
        {selectedImages.length > 0 && (
          <div className="photovault-preview-grid">
            {selectedImages.map((file, index) => (
              <div key={index} className="photovault-preview-item">
                <img
                  src={URL.createObjectURL(file)}
                  alt={`preview ${index + 1}`}
                  className="photovault-preview-img"
                />
                <button
                  type="button"
                  className="photovault-remove-btn"
                  onClick={() => removeImage(index)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        )}

        <div className="photovault-actions">
          <button
            type="button"
            className="photovault-clear-btn"
            onClick={clearAll}
            disabled={selectedImages.length === 0 || isSubmitting}
          >
            Clear All
          </button>

          <button
            type="submit"
            className="photovault-submit-btn"
            disabled={
              selectedImages.length === 0 ||
              isSubmitting ||
              selectedImages.length > MAX_IMAGES
            }
          >
            {isSubmitting
              ? "Uploading..."
              : `Upload ${selectedImages.length} Image${
                  selectedImages.length !== 1 ? "s" : ""
                }`}
          </button>
        </div>
      </form>

      <p className="photovault-info">
        {selectedImages.length} / {MAX_IMAGES} images selected
      </p>
    </div>
  );
};

export default PhotoVaultPictureAddForm;
